import { defineStore } from 'pinia'
import axios from '@/services/index.js'

export const useNotificationsStore = defineStore('notifications', {
  modelName: 'Notification',
  state: () => ({
    notifications: [],
    loading: false
  }),

  getters: {
    showNotifications: (state) => state.notifications,
    showCountNotifications: (state) => state.notifications.length,
    hasNotifications: (state) => state.notifications.length > 0
  },

  actions: {
    onModelChanged() {
      this.getNotifications()
    },

    async getNotifications() {
      this.loading = true
      
      try {
        const response = await axios.post('/api/notifications/list')
        if (response.data.success) {
          this.notifications = response.data.data
        }
      } catch (error) {
        console.error('Error fetching notifications:', error)
        this.notifications = []
      } finally {
        this.loading = false
      }
    },

    async delNotification(id) {
      this.loading = true

      try {
        const response = await axios.post(`/api/notifications/delete/${id}`)
        if (response.data.code === 201) {
          // Recargar las notificaciones
          await this.getNotifications()
        }
      } catch (error) {
        console.error('Error deleting notification:', error)
      } finally {
        this.loading = false
      }
    },

    async markAsSeen(id) {
      try {
        const response = await axios.get(`/api/notifications/checkSeen/${id}`)
        // Recargar las notificaciones después de marcar como vista
        await this.getNotifications()
        return response.data
      } catch (error) {
        console.error('Error marking notification as seen:', error)
        throw error
      }
    },

    setNotifications(notifications) {
      this.notifications = notifications
    },

    clearNotifications() {
      this.notifications = []
    }
  }
})